import { Stack } from "@mui/material";
import { useEffect } from "react";
import { useProgress } from "src/context/ProgressContext";
import { useQuestions } from "src/context/QuestionsProvider/useQuestions";
import QuestionHeader from "./components/QuestionHeader";
import QuestionBody from "./components/QuestionBody";
import QuestionFooter from "./components/QuestionFooter";

const Questions = () => {
  const questionType = useQuestions((q) => q.question_type);
  const questionPosition = useQuestions((q) => q.question_position);

  const { setCurrentStep, setLastMainPosition, lastMainPosition } =
    useProgress();

  useEffect(() => {
    if (questionPosition != null && questionPosition !== -1) {
      setLastMainPosition(questionPosition);
      setCurrentStep(questionPosition + 1);
    } else if (lastMainPosition != null) {
      setCurrentStep(lastMainPosition + 1);
    }
  }, [lastMainPosition, questionPosition, setCurrentStep, setLastMainPosition]);

  return (
    <Stack gap="20px">
      <QuestionHeader />

      <QuestionBody />

      {questionType !== "disqualification" ? <QuestionFooter /> : null}
    </Stack>
  );
};

export default Questions;
